import styled from 'styled-components';

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  width: 100%;
`;

export default LabelWrapper;